import { DIVISION_FIND_MANY } from '../lib/endpoints/category';
import axios from '../lib/axios';
import { DivisionModel } from '../models/division';

export const getDivisionByMerchantId = async ({
  merchantId,
}: {
  merchantId: string;
}): Promise<DivisionModel[]> => {
  const resData = await axios.post(DIVISION_FIND_MANY, { filter: { merchant_id: merchantId } });
  return resData?.data?.data;
};
